// AI Generated: Platform Partners component matching Figma design (node-id=1279-1748)
import React from 'react';
import styles from '$styles/ind/home/platformPartners.module.scss';

interface IPlatformPartnersProps {
  isMobile?: boolean;
  isDesktop?: boolean;
}

// Platform partner logos in exact order from Figma design
const platformLogos = [
  { src: '/public/images/platforms/makemytrip.png', alt: 'MakeMyTrip' },
  { src: '/public/images/platforms/goibibo.png', alt: 'GoIbibo' },
  { src: '/public/images/platforms/irctc.png', alt: 'IRCTC' },
  { src: '/public/images/platforms/amazonpay.png', alt: 'Amazon Pay' },
  { src: '/public/images/platforms/googlepay.png', alt: 'Google Pay' },
  { src: '/public/images/platforms/seatseller.png', alt: 'SeatSeller' },
];

const PlatformPartners: React.FC<IPlatformPartnersProps> = () => {
  return (
    <section className={styles.platformPartnersWrapper} data-component="platform-partners">
      <div className={styles.platformPartners}>
        <div className={styles.container}>
          <div className={styles.header}>
            <h2 className={styles.sectionTitle}>Go live across platforms</h2>
            <p className={styles.sectionSubtitle}>
              Maximize your reach with your inventory live on most of the major platforms
            </p>
          </div>
          <div className={styles.partnersGrid}>
            {platformLogos.map((logo, index) => (
              <div key={`partner-${index}`} className={styles.partnerCard}>
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className={styles.partnerLogo}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlatformPartners;
// AI Generated: End of platform partners component
